const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-emerald-dark border-t border-ivory/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <button onClick={scrollTop} data-testid="footer-logo" className="text-left">
          <span className="block font-display text-xl text-ivory">Dr. Priya H. Mishra</span>
          <span className="block text-[10px] uppercase tracking-[0.25em] text-champagne">
            Consultant Prosthodontist &amp; Implantologist
          </span>
        </button>
        <p className="text-ivory/40 text-xs tracking-wide">
          &copy; {new Date().getFullYear()} Dr. Priya H. Mishra. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
